import api from "./api";

export function getEricssonHssDefaultParameters() {
  return new Promise((resolve, reject) => {
    api
      .get("/ericsson-hss-default-parameters")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getById(id) {
  return new Promise((resolve, reject) => {
    api
      .get(`/ericsson-hss-default-parameters/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function update(values) {
  return new Promise((resolve, reject) => {
    api({
      method: "put",
      url: `/ericsson-hss-default-parameters`,
      data: values,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
